import { Provider } from '@angular/core';

import { GEO_COORDINATOR_CONFIG_PROVIDER_TOKEN, GEO_COORDINATOR_CONFIG_TOKEN } from '@frontend/geo-coordinator/client-stub';

import { ConfigProviderService } from '../../config-provider/config-provider.service';

export function provideGeoCoordinatorConfig(): Provider[] {
    return [
        {
            provide: GEO_COORDINATOR_CONFIG_TOKEN,
            useFactory: (configProviderService: ConfigProviderService) => configProviderService.provideGeoLocationConfig(),
            deps: [ConfigProviderService],
        },
        {
            provide: GEO_COORDINATOR_CONFIG_PROVIDER_TOKEN,
            useFactory: (configProviderService: ConfigProviderService) => {
                return {
                    provide: () => configProviderService.provideGeoLocationConfig(),
                };
            },
            deps: [ConfigProviderService],
        },
    ];
}
